<div *transloco="let t" class="grid grid-cols-1 lg:grid-cols-4 gap-4 p-4">
  <div class="lg:col-span-4 px-6 mb-2">
    <p-breadcrumb
      [model]="breadcrumbItems()"
      [style]="{background: 'transparent', border: 'none', padding: '0'}"
      data-testid="breadcrumb"
    ></p-breadcrumb>
  </div>

  @if (loading()) {
    <div class="lg:col-span-4 p-6 flex justify-center">
      <app-loading />
    </div>
  } @else if (project) {
    <div class="lg:col-span-4 px-6">
      <app-background-card testId="project-card" titleTestId="project-title" [title]="project.name">
        <p-card data-testid="project-header">
          <div class="mt-2 mb-2 text-base text-gray-400" data-testid="project-years">
            {{ t('wizard.project.yearsInScope') }}:
            <span class="ml-1 text-lg font-semibold text-gray-200">
              {{ project.yearsInScope }}
            </span>
          </div>
          <div
            [innerHTML]="project.description"
            class="text-base text-gray-200"
            data-testid="project-description"
          ></div>
        </p-card>

        <p-card class="mb-6" data-testid="user-management-card">
          <div class="font-semibold text-lg mb-4">
            {{ t('project.detail.userManagement') }}
          </div>
          <app-user-avatar-group
            [users]="projectUsers"
            [projectId]="project.id"
            data-testid="project-user-avatars"
          ></app-user-avatar-group>
        </p-card>

        <app-project-detail-list
          [project]="project"
          data-testid="project-chapter-list"
        ></app-project-detail-list>
      </app-background-card>
    </div>
  }
  <div class="lg:col-span-4 px-6">
    <app-project-detail-company-list
      [projectId]="project.id"
      [project]="project"
    ></app-project-detail-company-list>
  </div>
</div>
